/** Colores GEN-05 compartidos entre Buscar Traslados y Reportes (MLP-1824 / MLP-1828). */
export const TRASLADOS_ESTADOS_COLORES = {
  "Pendiente de validación datos": "#5B8DEF",
  "Pendiente Autorización": "#9B6DFF",
  Autorizado: "#7BC67E",
  Despachado: "#2E7D32",
  "Rechazado por Agencia": "#E57373",
  Negativo: "#FFB300",
  Rechazado: "#C62828",
  Cancelado: "#78909C",
  "Cancelado con penalidad": "#8D6E63",
  Cerrado: "#546E7A",
  "Cerrado Automáticamente": "#B0BEC5",
};
export const TRASLADOS_ESTADOS_NOMBRES = Object.keys(TRASLADOS_ESTADOS_COLORES);

export const TRASLADOS_ESTADOS_TERMINALES = [
  "Cancelado",
  "Cancelado con penalidad",
  "Cerrado",
  "Cerrado Automáticamente",
  "Negativo",
];

export const isTerminalEstadoTramo = (nombreOrCodigo) => {
  if (!nombreOrCodigo) return false;
  const clean = String(nombreOrCodigo).trim().toLowerCase();
  return TRASLADOS_ESTADOS_TERMINALES.some(
    (term) => term.toLowerCase() === clean
  );
};

const FALLBACK_COLOR = "#90A4AE";

export const getTrasladoEstadoColor = (nombreOrCodigo) => {
  if (!nombreOrCodigo) return FALLBACK_COLOR;
  if (TRASLADOS_ESTADOS_COLORES[nombreOrCodigo]) {
    return TRASLADOS_ESTADOS_COLORES[nombreOrCodigo];
  }
  const match = Object.keys(TRASLADOS_ESTADOS_COLORES).find(
    (key) => key.toLowerCase() === String(nombreOrCodigo).toLowerCase(),
  );
  return match ? TRASLADOS_ESTADOS_COLORES[match] : FALLBACK_COLOR;
};
